import { useRootStore } from '~/store/root'

export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server) {
    return
  }

  const nuxtApp = useNuxtApp()
  const { $lendioCookies, $pinia } = nuxtApp
  const rootStore = useRootStore($pinia)

  if (rootStore.isEmbedded || rootStore.expiryTimeoutSet) {
    return
  } else {
    rootStore.setupTokenExpirationTimeout()
  }
})
